

































































import { Component, Vue, Prop, InjectReactive, Watch, PropSync } from 'vue-property-decorator';
import { WithUID, generateUID } from '@/utils/utils';
import indexOf from 'lodash/indexOf';
import { PaycheckForm } from './PaycheckForm';
import { GQL_PaycheckPrepaymentUpdate } from '@/queries/global';
import { GQL_paycheckNewFragments_prepayments } from '@/queries/__generated__/paycheckNewFragments';
import Decimal from '@/utils/decimal';
import { WatchObjectAsJson } from '@/decorators/watch-object-as-json';

type PaycheckPrepayment = GQL_paycheckNewFragments_prepayments & GQL_PaycheckPrepaymentUpdate;

@Component
export default class PaycheckPrepayments extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;
  @InjectReactive() private isLocked!: boolean;
  @InjectReactive() private isPrint!: boolean;
  @InjectReactive() private hasEditPermissions!: boolean;

  @PropSync('sum', { type: Object, default: () => new Decimal(0) }) private sumSync!: Decimal;

  private get notDeletedLines(): WithUID<PaycheckPrepayment>[] {
    return (this.paycheck.prepayments as WithUID<PaycheckPrepayment>[]).filter((line: GQL_PaycheckPrepaymentUpdate) => !line._destroy);
  }

  private addLine(): void {
    (this.paycheck.prepayments as WithUID<PaycheckPrepayment[]>).push({
      id: null,
      amount: new Decimal(0),
      paymentDate: null,
      $_UID: generateUID(),
    } as WithUID<PaycheckPrepayment>);
  }

  private removeLine(line: WithUID<PaycheckPrepayment>): void {
    if (line.id) {
      this.$set(line, '_destroy', true);
    } else {
      this.paycheck.prepayments.splice(
        indexOf(this.paycheck.prepayments as WithUID<PaycheckPrepayment>[], line),
        1,
      );
    }
  }

  @Watch('paycheck.prepayments', { immediate: true })
  private ensureUIDsAreSet(): void {
    (this.paycheck.prepayments as WithUID<PaycheckPrepayment>[]).forEach(line => {
      if (!line.$_UID) {
        this.$set(line, '$_UID', generateUID());
      }
    });
  }

  @WatchObjectAsJson('paycheck.prepayments', { immediate: true })
  private syncSum(): void {
    this.sumSync = this.notDeletedLines.reduce((sum, line) => sum.add(line.amount), new Decimal(0));
  }
}
